/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import * as l10n from './avi-skip-link.l10n';
import './avi-skip-link.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Skip link used for accessibility purposes. Allows users utilizing keyboard controls who are
 *     tabbing through the application to skip navigation links and interact with the main content
 *     instantly.
 * @author alextsg
 */
@Component({
    selector: 'avi-skip-link',
    templateUrl: './avi-skip-link.component.html',
})
export class AviSkipLinkComponent {
    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Focus on the main content div.
     */
    public focusMain(event: Event): void {
        event.preventDefault();
        event.stopPropagation();

        // eslint-disable-next-line no-extra-parens
        (document.querySelector('[role=main]') as HTMLElement).focus();
    }
}
